export const GOOGLE_API_KEY = 'AIzaSyDN-tzMFZyrZ5euQTzqovCrjGQLVZXk2-k'
